export const workspace = {
  routes: [
    {
      path: "/workspace/library/transfering-method",
      component: () => import("../transfering-method/workspace-library-transfering-method-view"),
    },
    {
      path: "/workspace/library/transfering-prevention",
      component: () => import("../transfering-prevention/workspace-library-transfering-prevention-view"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/transfering-method",
      component: () => import("../transfering-method/management-library-transfering-method-view"),
    },
    {
      path: "/management/transfering-prevention",
      component: () => import("../transfering-prevention/management-library-transfering-prevention-view"),
    },
  ],
};
